// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4b21feae] .el-badge__content.is-fixed{top:10px!important;right:12px!important}", ""]);
// Exports
module.exports = exports;
